/**
 * Complete tour pop-up
 * @author Matt Haynes
 * @package Dunfermline
 */

const CompleteTour = tourData => {
    if (!tourData) return;
    const completeTour = document.getElementById('tour_complete');
    const visitedItems = localStorage.getItem(`visitedItems-${tourData[0].type}`);

    if (tourData.length === visitedItems.split(',').length) {
        completeTour.style.display = 'flex';
    }
};

export default CompleteTour;
